import { render, staticRenderFns } from "./StatsROAS.vue?vue&type=template&id=360278aa"
import script from "./StatsROAS.vue?vue&type=script&lang=js"
export * from "./StatsROAS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports